(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const lightbox = document.getElementById('lightbox');
    const inner = document.getElementById('lightboxInner');
    const content = document.getElementById('lightboxContent');
    const arrows = document.getElementById('lightboxArrows');
    const dots = document.getElementById('lightboxDots');
    if (!lightbox) return;

    let carouselIndex = 0;
    let carouselItem = null;

    function preloadImages(urls) {
      urls.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }

    function renderCarousel(item) {
      const slides = item.images && item.images.length ? item.images : [item.img];
      const total = slides.length;
      content.innerHTML = `<img src="${slides[carouselIndex]}" alt="${item.label || ''} — slide ${carouselIndex + 1} of ${total}" style="height:70vh;border-radius:10px;object-fit:cover;">`;
      dots.innerHTML = Array.from({ length: total })
        .map((_, i) => `<span class="${i === carouselIndex ? 'active' : ''}"></span>`)
        .join('');
    }

    function stepCarousel(dir) {
      if (!carouselItem) return;
      const total = carouselItem.images && carouselItem.images.length ? carouselItem.images.length : 1;
      carouselIndex = (carouselIndex + dir + total) % total;
      renderCarousel(carouselItem);
    }

    function open(item) {
      carouselIndex = 0;
      carouselItem = item;
      if (item.type === 'video') {
        inner.classList.add('is-video');
        if (item.video) {
          // No autoplay — the viewer presses play themselves once enlarged, matching the
          // grid tiles (which also no longer autoplay).
          content.innerHTML = `<video src="${item.video}" poster="${item.img || ''}" controls playsinline preload="metadata"></video>`;
        } else {
          content.innerHTML = `<img src="${item.img}" alt="${item.label || ''} — enlarged">`;
        }
        arrows.style.display = 'none';
        dots.innerHTML = '';
      } else if (item.type === 'carousel') {
        inner.classList.remove('is-video');
        renderCarousel(item);
        arrows.style.display = 'flex';
        // Preload every slide up front so stepping through the carousel is instant
        // instead of waiting on each image to fetch the moment it's navigated to.
        if (item.images && item.images.length) preloadImages(item.images);
      } else {
        inner.classList.remove('is-video');
        content.innerHTML = `<img src="${item.img}" alt="${item.label || ''} (enlarged)" style="height:70vh;border-radius:10px;object-fit:cover;">`;
        arrows.style.display = 'none';
        dots.innerHTML = '';
      }
      lightbox.classList.add('open');
    }

    function close() {
      const vid = content.querySelector('video');
      if (vid) vid.pause();
      lightbox.classList.remove('open');
    }

    document.getElementById('lbPrev').addEventListener('click', () => stepCarousel(-1));
    document.getElementById('lbNext').addEventListener('click', () => stepCarousel(1));
    document.getElementById('lightboxClose').addEventListener('click', close);
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let intentDecided = false;
    let isHorizontal = false;

    inner.addEventListener(
      'touchstart',
      (e) => {
        const t = e.touches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
        intentDecided = false;
        isHorizontal = false;
      },
      { passive: true }
    );
    inner.addEventListener(
      'touchmove',
      (e) => {
        const t = e.touches[0];
        const dx = t.clientX - touchStartX;
        const dy = t.clientY - touchStartY;
        if (!intentDecided && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          intentDecided = true;
          isHorizontal = Math.abs(dx) > Math.abs(dy);
        }
      },
      { passive: true }
    );
    inner.addEventListener(
      'touchend',
      (e) => {
        if (!isHorizontal || !carouselItem || carouselItem.type !== 'carousel') return;
        const t = e.changedTouches[0];
        const dx = t.clientX - touchStartX;
        if (Math.abs(dx) > 40) stepCarousel(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );

    let dragStartX = 0;
    let dragging = false;
    let dragMoved = false;
    inner.addEventListener('mousedown', (e) => {
      if (e.target.closest('button')) return;
      dragging = true;
      dragStartX = e.clientX;
      dragMoved = false;
    });
    window.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      if (Math.abs(e.clientX - dragStartX) > 6) dragMoved = true;
    });
    window.addEventListener('mouseup', (e) => {
      if (!dragging) return;
      dragging = false;
      if (!dragMoved || !carouselItem || carouselItem.type !== 'carousel') return;
      const dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 40) stepCarousel(dx < 0 ? 1 : -1);
    });

    window.SiscodeLightbox = { open, close };
  });
})();
